export default function MySQL_NOTNULL() {
  return (
    <div>
      <h2>MySQL_NOTNULL</h2>    </div>
  );
}